window.okeReviewsWidgetOnInit = function () {
    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach(n => setupReviews(n));
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(reviewMain, { childList: true });
        // Run callback for the first time
        const reviews = document.querySelectorAll('.okeReviews-reviews-review');
        reviews.forEach(n => setupReviews(n));
    }
  
  	const totalSummary = document.querySelector('.okeReviews-reviewsAggregate-summary-total');
  
    // Removes all non-numeric characters in the text.
    if (totalSummary) {
        totalSummary.innerText = totalSummary.innerText.replace(/\D/g,''); 
    }

    const reviewsControlSelect = document.querySelector('.okeReviews-reviews-controls-select');
    const reviewsFilter = document.querySelector('.js-okeReviews-filters');
    if(reviewsControlSelect && reviewsFilter) {
        // Move Controls Select after the Review Filter
        reviewsFilter.insertAdjacentElement('afterbegin', reviewsControlSelect);
    }
};

function setupReviews(nodeElement) {
    const reviewSelectAttributes = nodeElement.querySelector('.okeReviews-review-selectAttributes');
    const reviewContent = nodeElement.querySelector('.js-okeReviews-reviewContent');
    if(reviewSelectAttributes && reviewContent) {
        // Move Review Select Attributes after the review content
        reviewContent.insertAdjacentElement('afterend', reviewSelectAttributes);
    }

}